// Api endpoints
import axios from 'axios';

// Select the appropriate base URL for development vs production
// In production on Vercel, this will point to your SparkHost backend
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://verify-api.breathofestova.com'
  : 'http://localhost:5000';

// Default axios configuration for API requests
export const configureAxios = () => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  axios.defaults.headers.common['Content-Type'] = 'application/json';
};

// Auth endpoints
export const DISCORD_AUTH_URL = `${API_BASE_URL}/api/auth/discord`;
export const DISCORD_CALLBACK_URL = `${API_BASE_URL}/api/auth/discord/callback`;
export const AUTH_STATUS_URL = `${API_BASE_URL}/api/auth/status`;
export const GET_USER_URL = `${API_BASE_URL}/api/user`;
export const LOGOUT_URL = `${API_BASE_URL}/api/auth/logout`;

// NFT verification endpoints
export const VERIFY_NFT_URL = `${API_BASE_URL}/api/verify/nft`;
export const ROLE_STATUS_URL = `${API_BASE_URL}/api/role/status`;

// Signature verification endpoints
export const NONCE_URL = `${API_BASE_URL}/api/nonce`;
export const VERIFY_SIGNATURE_URL = `${API_BASE_URL}/api/verify/signature`;

// Create a function to handle api requests
export const fetchWithCredentials = async (url, options = {}) => {
  // Set credentials to include for cross-origin requests
  const fetchOptions = {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(url, fetchOptions);
    
    // Handle non-OK responses
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Request failed with status ${response.status}`);
    }
    
    // Parse JSON response if present
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    }
    
    return await response.text();
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
};

// New endpoint
export const ASSIGN_ROLE_URL = `${API_BASE_URL}/api/role/assign`; 